import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavigationHistoryService {
  private visited: boolean = false;

  markVisited() {
    this.visited = true;
  }

  hasVisited(): boolean {
    return this.visited;
  }
}
